export class CurbsideDetail {
    id: number;
    label: string;
    value: string;
    isrequired: boolean;
    validationregex: string;
    scope: string;
}
